import { DateTimeStr } from '@mi-front/core';
import { LocaleRelativeTime } from '@mi-front/ui';
import { Box, Typography } from '@mui/material';
import { LDate } from '../LDate';
import { LTime } from '../LTime';

interface DateTimeAgoProps {
  value: DateTimeStr | string;
  showSeconds?: boolean;
}

export const DateTimeAgo = (p: DateTimeAgoProps) => {
  const { value, showSeconds = false } = p;

  return (
    <Box display="inline-flex" flexDirection="column">
      <Box
        sx={{
          '&::first-letter': {
            textTransform: 'uppercase',
          },
        }}
      >
        <LocaleRelativeTime value={value} />
      </Box>
      <Typography color="text.disabled" fontSize="0.7rem" component="div">
        <Box component="span" display="inline-flex" gap={0.75}>
          <LDate value={value as DateTimeStr} day="2-digit" month="2-digit" year="2-digit" />
          <LTime value={value as DateTimeStr} showSeconds={showSeconds} />
        </Box>
      </Typography>
    </Box>
  );
};
